if (document.querySelector('.sc-recipe-card-list')) {
  const recipeListSection = document.querySelector('.sc-recipe-card-list');
  const recipeNumberText = recipeListSection.querySelector('.sc-recipe-card-list .recipe-card-list__total p');
  const form = recipeListSection.querySelector('form.product-filter__form');

  const filterButtons = recipeListSection.querySelectorAll('.product-filter .dropdown__list-item input');
  const clearFilters = recipeListSection.querySelectorAll('.product-filter__reset-btn, .recipe-list__reset-btn');
  const recipeList = recipeListSection.querySelector('.recipe-card-list__inner');

  form.addEventListener('submit', (event) => {
    event.preventDefault();
  });
  const getSelectedItems = (selector) =>
    [...document.querySelectorAll(selector)].filter((input) => input.checked).map(({ value }) => value);

  const loadMoreAxios = (pageNumber = 1) => {
    document
      .querySelector('.sc-recipe-card-list .product-filter')
      .scrollIntoView({ behavior: 'smooth', block: 'start' });

    const formDataInput = new FormData();
    formDataInput.append('action', 'recipeLoadMore');
    formDataInput.append('primary', recipeListSection.dataset.categories);
    const checkedValues = [
      // eslint-disable-next-line no-useless-concat
      ...document.querySelectorAll('.product-filter__filter .dropdown__list' + ' input:checked'),
    ].map((input) => input.value);

    formDataInput.append('filters', checkedValues.join(','));
    formDataInput.append('per_page', getSelectedItems('.pagination__footer input'));
    formDataInput.append('number', pageNumber);
    axios
      .post(localData.apiURL, formDataInput, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        let url = '';
        ['filters', 'number', 'per_page'].forEach((item) => {
          if (formDataInput.get(item)) {
            url += `${item}=${formDataInput.get(item)}&`;
          }
        });
        window.history.pushState({ urlPath: window.location.href }, null, `?${url}`);
        recipeList.innerHTML = response.data.recipes;
        document.querySelector('.recipe-card-list__footer').innerHTML = response.data.pagination;
        recipeNumberText.innerHTML = response.data.number_recipes;
      })
      .finally(() => {
        dropdownGlobalHandler();
      })
      .catch((err) => {
        console.error(err);
      });
  };
  if (clearFilters) {
    clearFilters.forEach((clearFilter) => {
      clearFilter.addEventListener('click', () => {
        filterButtons.forEach((button) => {
          button.checked = false;
        });
        setTimeout(() => {
          loadMoreAxios();
        }, 200);
      });
    });
  }
  filterButtons.forEach((filter) => {
    filter.addEventListener('click', (event) => {
      if (event.isTrusted) {
        document.querySelectorAll(`input[value="${event.target.value}"]`).forEach((el) => {
          if (el.id !== event.target.id) {
            el.click();
          }
        });
        loadMoreAxios();
      }
    });
  });
  // clear each filter click
  attachEvent('button.product-filter__selected, [data-reset-filter]', 'click', () => {
    setTimeout(() => {
      loadMoreAxios();
    }, 200);
  });
  // pagination clicker and number of recipes on list
  attachEvent('.recipe-card-list__footer .page-numbers, .pagination__footer input', 'click', (event) => {
    event.preventDefault();
    loadMoreAxios(Number(event.target.closest('a')?.dataset?.page ?? 1));
  });
  // clear each cloud filter click
  attachEvent('.product-filter__selected', 'click', (event) => {
    const { filterId } = event.target.dataset;
    const input = document.querySelector(
      `.filter-modal__body input[type="checkbox"][value="${parseInt(filterId.replace('filter-', ''), 10)}"]`,
    );
    if (input && input.checked && !event.isTrusted) {
      input.click();
    }
  });
}
